import { render, staticRenderFns } from "./OpcoesAvancadas.vue?vue&type=template&id=3bc1868e"
import script from "./OpcoesAvancadas.vue?vue&type=script&lang=js"
export * from "./OpcoesAvancadas.vue?vue&type=script&lang=js"
import style0 from "./OpcoesAvancadas.vue?vue&type=style&index=0&id=3bc1868e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports